import { createContext, Dispatch, SetStateAction, useMemo, useState } from 'react'

import { useBalances } from '@/hooks/use-balances'
import useDepositTokenOptions from '@/hooks/use-deposit-token-options'
import { CustomTokenInfo } from '@/utils/helpers'

export type ContextType = {
  selectedToken: CustomTokenInfo | null
  setSelectedToken: Dispatch<SetStateAction<CustomTokenInfo | null>>
  prevTokenBalance: number
  tokenOptions: CustomTokenInfo[]
}

export const initValue: ContextType = {
  selectedToken: null,
  setSelectedToken: () => null,
  prevTokenBalance: 0,
  tokenOptions: [],
}

export const WrappedTokensFlowContext = createContext<ContextType>(initValue)
export const WrapperTokensFlowProvider = ({ children }: HocProps) => {
  const { balances } = useBalances()
  const [selectedToken, setSelectedToken] = useState<CustomTokenInfo | null>(null)
  const { tokenOptions } = useDepositTokenOptions()

  const prevTokenBalance = useMemo(() => {
    if (!selectedToken) return 0
    return balances[selectedToken.symbol] || 0
    // store the previous balance based on the selectedToken, no need update when the balances are changed
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedToken])

  const ctxValue = useMemo(() => ({
    selectedToken,
    setSelectedToken,
    prevTokenBalance,
    tokenOptions,
  }) ,[selectedToken, prevTokenBalance, tokenOptions])

  return (
    <WrappedTokensFlowContext.Provider value={ctxValue}>
      {children}
    </WrappedTokensFlowContext.Provider>
  )
}
